<template>
    <div>

        <div :class="view_class_view.div_container">

            <!-- Select countries -->
            <div  :class="view_class_view.choose_button_nacionality">
                <ChooseButton 
                    :buttons="buttonsNacionality"
                    v-on:choose-button="get_value_choose_button_nacionality($event)"
                    v-model="buttonsCountry"
                    label="País:" 
                    :buttons_styles="buttons_styles"
                />
 
            </div>

            <!-- Select countries -->
            <div v-show="showInputCountry && countries.length > 0" :class="view_class_view.div_container_countries">
                <label :class="view_class_view.input_label" for="button_country_birthplace">País:</label>
                <select id="button_country_birthplace"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: birthpPlaceModelValidation.country.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!birthpPlaceModelValidation.country.$invalid,
                [view_class_view.input_class.default ]: birthpPlaceModelValidation.country.$invalid && !birthpPlaceModelValidation.country.$error  }"
                v-model="birthPlace.country"
                @blur="birthpPlaceModelValidation.country.$validate">
                    <option value="" selected disabled>Seleccione un país</option>
                    <option v-for="country in countries" :key="country.value" :value="country.value" :disabled="(country.value=='México')? true: false">
                        {{ country.text }}
                    </option>
                </select>

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of birthpPlaceModelValidation.country.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div v-show="!showInputCountry && states.length > 0" :class="view_class_view.div_conatiner_states">
                <label :class="view_class_view.input_label" for="select_state_birthplace"> Estado: </label>
                <select id="select_state_birthplace"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: birthpPlaceModelValidation.state.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!birthpPlaceModelValidation.state.$invalid,
                [view_class_view.input_class.default ]: birthpPlaceModelValidation.state.$invalid && !birthpPlaceModelValidation.state.$error  }"
                v-model="birthPlace.state"
                @blur="birthpPlaceModelValidation.state.$validate">
                <option value="" selected disabled>Seleccione un estado</option>
                    <option v-for="state in states" :key="state.value" :value="state.value">{{ state.text }}</option>
                </select>
            
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of birthpPlaceModelValidation.state.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <!-- Select municipalities -->
            <div v-show="!showInputCountry && municipalities.length > 0" :class="view_class_view.div_conatiner_municipalities">
                <label  for="select_municipality_birthplace">Municipio:</label>
                <select id="select_municipality_birthplace"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: birthpPlaceModelValidation.municipality.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!birthpPlaceModelValidation.municipality.$invalid,
                [view_class_view.input_class.default ]: birthpPlaceModelValidation.municipality.$invalid && !birthpPlaceModelValidation.municipality.$error  }"
                v-model="birthPlace.municipality"
                @blur="birthpPlaceModelValidation.municipality.$validate">
                <option value="" selected disabled>Seleccione un municipio</option>
                <option v-for="municipality in municipalities" :key="municipality.value" :value="municipality.value">{{ municipality.text }}</option>
                </select>

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of birthpPlaceModelValidation.municipality.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <!-- Select cities -->
            <div v-show="!showInputCountry && cities.length > 0" :class="view_class_view.div_conatiner_cities">
                <label :class="view_class_view.input_label" for="select_city_birthplace">Ciudad:</label>
                <select id="select_city_birthplace"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: birthpPlaceModelValidation.city.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!birthpPlaceModelValidation.city.$invalid,
                [view_class_view.input_class.default ]: birthpPlaceModelValidation.city.$invalid && !birthpPlaceModelValidation.city.$error  }"
                v-model="birthPlace.city"
                @blur="birthpPlaceModelValidation.city.$validate">
                <option value="" selected disabled>Seleccione una ciudad</option>
                <option v-for="city in cities" :key="city.value" :value="city.value" >{{ city.text }}</option>
                </select>

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of birthpPlaceModelValidation.city.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

        </div>


        
    </div>
</template>

<script>
import ChooseButton from './Forms/ChooseButton.vue';
import { onMounted, ref, toRef, watch } from 'vue';
import axios from 'axios';
import useVuelidate from '@vuelidate/core';
export default({
    name:"BirthPlace",
    components:{
        ChooseButton
    },
    props:{
        buttons_styles:{
            type: Object,
            default(){
                return {
                    buttonSelected:"",
                    activeColorBackground: '#EA7F0B !important',
                    inactiveColorBackground: '#FFFFFF !important',
                    activeColorText: '#FFFFFF !important',
                    inactiveColorText: '#EA7F0B !important',
                    activeBorderColor: '#EA7F0B',
                    inactiveBorderColor: '#EA7F0B'
                };
            }
        },
        key_token_storage:{
            type: String,
            default(){
                return "";
            }
        },
        urlAPI:{
            type: String,
            default(){
                return "";
            }
        },
        view_class_view:{
            type: Object,
            default(){
                return {
                    input_label: "",
                    input_class:{
                        valid:"border-blue-600",
                        no_valid:"border-red-600",
                        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
                    },
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                    div_container:"flex flex-wrap mb-6 mt-5 ml-8",
                    choose_button_nacionality:"flex flex-wrap w-full inline md:w-1/3 mb-6 md:mb-6",
                    div_container_countries: "w-full md:w-1/3 px-3 mb-6 md:mb-6",
                    div_conatiner_states:"w-full md:w-1/3 px-3 mb-6 md:mb-6",
                    div_conatiner_municipalities:"w-full md:w-1/3 px-3 mb-6 md:mb-6",
                    div_conatiner_cities:"w-full md:w-1/3 px-3 mb-6 md:mb-6"
                }
            }
        },
        validations: {
            type: Object,
            default(){
                return {};
            }
        },
        show_external_countries: {
            type: Boolean,
            default(){
                return true;
            }
        }
    },
    setup(props) {
        let showInputCountry = ref(false);
        let municipality_selected = ref()
        let city_selected = ref();

        const countries = ref([]);
        const states = ref([]);
        const municipalities = ref([]);
        const cities = ref([]);
        const showExternalCountries = toRef(props, 'show_external_countries')
        const buttonsNacionality = [
            { id: 'button_mexico_birthplace', value: false, text: 'México' },
            { id: 'button_other_birthplace', value: true, text: 'Otro' }
        ];

        const birthPlace = ref(
            {
                country: "",
                state: "",
                municipality: "",
                city: ""
            },
        );

        const birthpPlaceModelValidation = useVuelidate(props.validations,birthPlace);
        const buttonsCountry = ref();

        onMounted(() => {
            get_value_choose_button_nacionality(false);
            if(!showExternalCountries.value){
                buttonsNacionality.pop();
            }
        });

        watch( () => birthPlace.value.state , (value) => {
            reload_inputs("state");
            if (value != "") {
                get_municipalities(value);
                return;
            }
        });

        watch( () => birthPlace.value.municipality , (value) => {
            get_cities(birthPlace.value.state, value);
            if (value != "") {
                reload_inputs("municipality");
                return;
            }
        });

        watch( () => buttonsCountry.value , () => {
            if(buttonsCountry.value == false){//Si selecciono la opcion de Nacionalidad México
                birthPlace.value.country = "México";
            }else if(birthPlace.value.country == "México" && buttonsCountry.value == true){//Si selecciono la opcion de Otra nacionalidad
                birthPlace.value.country = "";
            }
        });
        
        watch( () => municipalities.value, () => {
            birthPlace.value.municipality = municipality_selected.value
        });

        watch( () => cities.value, () => {
            birthPlace.value.city = city_selected.value;
        });


        function get_value_choose_button_nacionality(status){
            showInputCountry.value = status;
            birthPlace.value.country = status;
            buttonsCountry.value = status;
            
            reload_inputs();// Limpiar otros inputs
            birthpPlaceModelValidation.value.$reset();

            if(!status){
                //Cargar estados
                get_states();
            }else{
                //Cargar países
                get_countries();
            }
        }

        function get_states() {

            const API_URL = `https://anter.com.mx:3001/Api/Catalogo/Sepomex/obtener_estados?token_auth=${sessionStorage.getItem(`${props.key_token_storage}`)}`;

            const header = {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                auth: {
                    username: "multicr",
                    password: "*cabsa2018*"
                }
            }

            axios.post(API_URL,{},header).then( response => {
                
                if(!response.data.Estados){
                    throw "countries not found";
                }

                const resp = response.data.Estados;
                states.value = resp.map(function(x) {
                    return { value: x.nombre, text: x.nombre };
                });

            }).catch( error =>{
                console.log(error);
            });
        }

        function get_countries() {

            const API_URL = `${props.urlAPI}/foncabsa/catalog_country/get_all?token_auth=${sessionStorage.getItem(`${props.key_token_storage}`)}`;

            const header = {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                }
            }

            axios.get(API_URL,header).then( response => {
                
                if(!response.data.response.countries){
                    throw "states not found";
                }

                const resp = response.data.response.countries;
                countries.value = resp.map(function(x) {
                    return { value: x.name, text: x.name };
                });

            }).catch( error =>{
                console.log(error);
            });
        }

        function get_municipalities(state) {

            const API_URL = `https://anter.com.mx:3001/Api/Catalogo/Sepomex/obtener_municipios_por_estado?token_auth=${sessionStorage.getItem(`${props.key_token_storage}`)}`;

            const header = {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                auth: {
                    username: "multicr",
                    password: "*cabsa2018*"
                }
            }

            const params = {
                contenido: {
                    estado: state,
                },
            }

            axios.post(API_URL,params,header).then( response => {
                
                if(!response.data.municipios){
                    throw "municipalities not found";
                }

                const resp = response.data.municipios;
                municipalities.value = resp.map(function(x) {
                    return { value: x.nombre, text: x.nombre };
                });

            }).catch( error =>{
                console.log(error);
            });
        }

        function get_cities(state, municipality){

            const API_URL = `https://anter.com.mx:3001/Api/Catalogo/Sepomex/obtener_ciudades_por_estado_y_municipio?token_auth=${sessionStorage.getItem(`${props.key_token_storage}`)}`;

            const header = {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                auth: {
                    username: "multicr",
                    password: "*cabsa2018*"
                }
            }

            const params = {
                contenido: {
                    estado: state,
                    municipio: municipality
                },
            }

            axios.post(API_URL,params,header).then( response => {
                
                if(!response.data.ciudades){
                    throw "cities not found";
                }

                const resp = response.data.ciudades;
                cities.value = resp.map(function(x) {
                    return { value: x.nombre, text: x.nombre };
                });

                birthPlace.value.city = (cities.value.length == 1)? cities.value[0].text : "";
                
            }).catch( error =>{
                console.log(error);
            });
        }

        function reload_inputs(exceptionInput="") {
            
            switch (exceptionInput) {
                case "country":
                    states.value = [];
                    municipalities.value = [];
                    cities.value = [];

                    birthPlace.value.state = "";
                    birthPlace.value.municipality = "";
                    birthPlace.value.city = "";
                break;
                case "state":
                    municipalities.value = [];
                    cities.value = [];

                    birthPlace.value.municipality = "";
                    birthPlace.value.city = "";
                break;
                case "municipality":
                    cities.value = [];
                    // city.value = "";
                break;
                default:
                    countries.value = [];
                    states.value = [];
                    municipalities.value = [];
                    cities.value = [];

                    birthPlace.value.country = "";
                    birthPlace.value.state = "";
                    birthPlace.value.municipality = "";
                    birthPlace.value.city = "";
                break;
            }
        }

        function execute_validation(){
            birthpPlaceModelValidation.value.$validate();
            if(birthpPlaceModelValidation.value.$error){
                return false;
            }
            return birthPlace.value;
        }

        return { 
            birthPlace,
            buttonsNacionality,
            showInputCountry,
            states,
            countries,
            municipalities,
            cities,
            birthpPlaceModelValidation,
            get_value_choose_button_nacionality,
            execute_validation,
            buttonsCountry,
            municipality_selected,
            city_selected
        }        
    }
});
</script>
